import { defineMessages } from 'react-intl'

const messages = defineMessages({
  category: {
    id: 'global.category',
  },
})

export default messages
